import sanyoPhoto from "@/assets/B44A4741.jpg.asset.json";
import tamaraPhoto from "@/assets/DSC02411.jpg.asset.json";
import type { FeaturedRacketTheme } from "@/lib/featured-rackets";

export interface SignatureSlideConfig {
  /** Existing product SKU — all product data comes from the database. */
  sku: string;
  player: string;
  theme: FeaturedRacketTheme;
  /** Swap these URLs (or the imported asset pointers) to replace the photos. */
  photo: {
    desktop: string;
    /** Optional separate mobile crop; falls back to the desktop image. */
    mobile?: string;
  };
  /** CSS object-position so faces/rackets stay visible when cropped. */
  focus: {
    desktop: string;
    mobile: string;
  };
}

/** Set to false to hide the homepage carousel (regular sections stay intact). */
export const SIGNATURE_CAROUSEL_ENABLED = true;
/** Set to false to render the two slides as static cards instead of a carousel. */
export const SIGNATURE_CAROUSEL_AUTOPLAY = true;
export const SIGNATURE_AUTOPLAY_MS = 5500;

export const SIGNATURE_SLIDES: SignatureSlideConfig[] = [
  {
    sku: "PC-STA-RAC-71I7",
    player: "Sanyo Gutiérrez",
    theme: "gold",
    photo: { desktop: sanyoPhoto.url },
    focus: { desktop: "50% 30%", mobile: "50% 25%" },
  },
  {
    sku: "PC-STA-RAC-I4Z9",
    player: "Tamara Icardo",
    theme: "wine",
    photo: { desktop: tamaraPhoto.url },
    focus: { desktop: "50% 35%", mobile: "50% 30%" },
  },
];

const PLAYER_BY_SKU: Record<string, string> = SIGNATURE_SLIDES.reduce(
  (acc, slide) => ({ ...acc, [slide.sku]: slide.player }),
  {}
);

export function getSignaturePlayer(sku?: string): string | null {
  if (!sku) return null;
  return PLAYER_BY_SKU[sku.trim().toUpperCase()] ?? null;
}
